import Gator from 'gator';
import { getParents, jump, nodeArray } from '../../General';

const documentClassList = document.documentElement.classList;
const documentOpenClass = '-image-teaser-open';
const elementOpenClass = 'image-teaser--open';

Gator(document).on('click', '.image-teaser__overlay,.image-teaser__close', function () {
    documentClassList.remove(documentOpenClass);
    const parent = getParents(this, '.image-teaser')[0];
    parent.classList.remove(elementOpenClass);
});

Gator(document).on('click', '.image-teaser__expand', function () {
    const parent = getParents(this, '.image-teaser')[0];
    parent.querySelector('.image-teaser__sidebar').scrollTop = 0;
    documentClassList.add(documentOpenClass);
    jump(parent, {
        duration: 500,
    });
    parent.classList.add(elementOpenClass);
});

let animationFrame;
let timeout;
Gator(window).on('resize', () => {
    if (animationFrame) {
        window.cancelAnimationFrame(animationFrame);
    }
    if (timeout) {
        window.clearTimeout(timeout);
    }

    animationFrame = window.requestAnimationFrame(() => {
        timeout = setTimeout(() => {
            if (documentClassList.contains(documentOpenClass)) {
                const element = document.querySelector(`.${elementOpenClass}`);

                if (element) {
                    jump(element, {
                        duration: 200,
                    });
                }
            }
        }, 500);
    });
});
